import { DarkTheme, DefaultTheme, ThemeProvider } from '@react-navigation/native';
import { useFonts } from 'expo-font';
import { Slot, Stack } from 'expo-router';
import * as SplashScreen from 'expo-splash-screen';
import React, { useEffect, useState } from 'react';
import { Platform, View } from 'react-native';
import { useColorScheme } from '@/hooks/useColorScheme';
import { useRouter } from 'expo-router';
import { usePersistBoundStore, usePersistSecureBoundStore } from '@/services/zustand/Store';
import Pushy from 'pushy-react-native';
import { useHandleNotificationEntry } from '@/services/notifications/useHandleNotificationEntry';
//SplashScreen.preventAutoHideAsync();

export default function RootLayout() {
  const user = usePersistSecureBoundStore((state) => state.user);
  const offlineDuration = usePersistBoundStore((state) => state.offlineDuration);
  const notificationSettings = usePersistBoundStore((state) => state.notificationSettings);
  const favouriteEdition = usePersistBoundStore((state) => state.favouriteEdition);  

  const colorScheme = useColorScheme();
  const router = useRouter();
  const [stackName, setStackName] = useState<`(auth)` | `(tabs)` | null>(null);
  const [registeredDviceToken, setRegisteredDeviceToken] = useState(false)
  const handleNotificationEntry = useHandleNotificationEntry();

  const [fontsLoaded] = useFonts({
    SpaceMono: require('../assets/fonts/SpaceMono-Regular.ttf'),
  });
  useEffect(() => {
    const registerPushy = async () => {
      try {
        if (!registeredDviceToken) {
          const deviceToken = await Pushy.register();
          //console.log('Pushy device token: ' + deviceToken);

          // Subscribe to topics
          await Pushy.subscribe('News');
          //console.log('Successfully subscribed to News topic');

          await Pushy.subscribe('Epaper');
          //console.log('Successfully subscribed to Epaper topic');

          setRegisteredDeviceToken(true);
        }
      } catch (err) {
        console.error('Pushy registration failed:', err);
        setRegisteredDeviceToken(false);
      }
    };

    if (fontsLoaded && (Platform.OS === 'android' || Platform.OS === 'ios')) {
      registerPushy();
    }
  }, [fontsLoaded, registeredDviceToken]);

  useEffect(() => {
    if (Platform.OS === 'android' || Platform.OS === 'ios') {
      Pushy.toggleInAppBanner(true);

      Pushy.setNotificationListener(async (data: any) => {
        let notificationTitle = 'BoyensApp';
        let notificationText = data.message || 'Test notification';

        if (Platform.OS === 'android') {
          Pushy.notify(notificationTitle, notificationText, data);
        }

        Pushy.setBadge(0);
      });
    }
  }, [registeredDviceToken]);

  useEffect(() => {
    if (Platform.OS === 'android' || Platform.OS === 'ios') {
      Pushy.setNotificationClickListener(async (data: any) => {
        //console.log("App.tsx NotificationClicker", data);

        let parsedData: any;
        try {
          parsedData = typeof data === "string" ? JSON.parse(data) : data;
        } catch (err) {
          console.error("Failed to parse notification data:", err);
          return;
        }
        //console.log(parsedData.target)
        handleNotificationEntry(parsedData);
      });

      Pushy.listen();
    }
  }, []);

  if (fontsLoaded && (Platform.OS === 'android' || Platform.OS === 'ios')) {
    Pushy.toggleInAppBanner(true);
  }

  useEffect(() => {
    if (fontsLoaded) {
      SplashScreen.hideAsync();
    }
  }, [fontsLoaded]);

  useEffect(() => {
    setStackName(user ? "(tabs)" : "(auth)");
    //console.log("layout.tsx - user: ", user);
    //console.log("layout.tsx - notificationSettings: ", notificationSettings);
    //console.log("layout.tsx - favouriteEdition: ", favouriteEdition);
    //console.log("layout.tsx - offlineDuration: ", offlineDuration);
  }, [user]);

  useEffect(() => {
    if (stackName) {
      router.replace({ pathname: `/${stackName}` });
      //console.log("_layout.tsx stackName:", stackName);
    }
  }, [stackName]);

  if (!fontsLoaded || stackName === null) {
    return (
      <Slot />
    );
  }

  return (
    <ThemeProvider value={colorScheme === 'dark' ? DarkTheme : DefaultTheme}>
      <View style={{ flex: 1 }}>
        {stackName === '(tabs)' ? (
          <Stack>
            <Stack.Screen name="(tabs)" options={{ headerShown: false }} />
            <Stack.Screen name="Datepicker" options={{ headerShown: true, presentation: 'modal' }} />
            <Stack.Screen name="Editionpicker" options={{ headerShown: true, presentation: 'modal' }} />
          </Stack>
        ) : (
          <Stack>
            <Stack.Screen name="(auth)" options={{ headerShown: false }} />
            <Stack.Screen name="Datepicker" options={{ headerShown: true, presentation: 'modal' }} />
            <Stack.Screen name="Editionpicker" options={{ headerShown: true, presentation: 'modal' }} />
          </Stack>
        )}
      </View>
    </ThemeProvider>
  );
}